var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){return _vm.$emit('help')}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-help-circle-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }